var map = {
	"./AboutUs.jpg": 649,
	"./ChiefIncumbentThero.jpg": 164,
	"./Committee.jpg": 697,
	"./Event-25April2025.jpg": 689,
	"./SilProgram.jpg": 516,
	"./Slider-1.jpg": 73,
	"./Slider-2.jpg": 958,
	"./SpecialEvent-April25.jpg": 415,
	"./SundaySchool.jpg": 328,
	"./VenSThero.jpg": 712
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;